import { AboutRoutesConfiguration } from './about_routes';
import { AboutHomeComponent } from './components/about_home/about_home';
import { AboutConfigComponent } from './components/about_config/about_config';
import { AboutReleaseComponent } from './components/about_release/about_release';
import { AboutTogglesComponent } from './components/about_toggles/about_toggles';
import { AboutDeviceComponent } from './components/about_device/about_device';

angular
  .module('about', [])
  .component('aboutHome', new AboutHomeComponent())
  .component('aboutConfig', new AboutConfigComponent())
  .component('aboutRelease', new AboutReleaseComponent())
  .component('aboutToggles', new AboutTogglesComponent())
  .component('aboutDevice', new AboutDeviceComponent())
  .provider('ngAboutRoutesConfiguration', AboutRoutesConfiguration);

require('./commands/get_server_deploy_detials');



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/about/about_module.ts